"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDealLabel = void 0;
var _tsUtils = require("@ori/ts-utils");
var _isDealLabel = require("./isDealLabel");
const getDealLabel = labels => labels?.find(label => (0, _tsUtils.isNonNullable)(label) && label.labelKey && (0, _isDealLabel.isDealLabel)(label.labelKey)) ?? null;
exports.getDealLabel = getDealLabel;
